module.exports = __webpack_public_path__ + "img/message-dots-square.12a55fa6.svg";